import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { getConfigClientFromRTE } from '@src/app/core/config/config-client';
import { GiftingIntelledoxRedirectContinue } from '@store/actions/intelledox-redirect/intelledox-redirect.actions';
import { switchMap } from 'rxjs';

import { External } from '../../actions';

@Injectable()
export class GiftingIntelledoxRedirectEffects {
  constructor(private readonly actions$: Actions) {}

  giftingIntelledoxRedirectContinue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GiftingIntelledoxRedirectContinue),
        switchMap(() => {
          const config = getConfigClientFromRTE();
          const url = config.pretty_ecs_domain + config.giftingIntelliDocs_endpoint;
          const actions = [];

          actions.push(External({ url }));

          return actions;
        }),
      ),
    { dispatch: true },
  );
}

export const effects: any[] = [GiftingIntelledoxRedirectEffects];
